<!--------------------------------------------------------------------------------------------------------->
<!--                                         THIS FILE IS NOT USED                                       -->
<!--                                         NEEDS TO BE IMPLEMENTED, DO NOT DELETE                      -->
<!--------------------------------------------------------------------------------------------------------->
<template>
	<div>
		
		<div class="ss-header">
			<div class="ss-header-name">My Schedule with Janny Black</div>
		</div>
		
		<div class="ss-schedules-area">
			
			<div class="ss-schedules-msg">
				<span class="ss-msg-date">12th Jul 2019</span>
				<p class="ss-msg-text">Shared expenses recuring payment with spouse Janny Black</p>
				<span class="ss-msg-amount">My share: <strong>£380.00</strong></span>
			</div>
			
			<div class="ss-schedules-msg">
				<span class="ss-msg-date">13th Jul 2019</span>
				<p class="ss-msg-text">Event Picking up Jack and Michael from school and droping them off to spouse’ house. </p>
				<span class="ss-msg-amount">My share: <strong>£380.00</strong></span>
			</div>
			
			<div class="ss-schedules-msg">
				<span class="ss-msg-date">15th Jul 2019</span>
				<p class="ss-msg-text">Child Maintenance Weekly payment for Jack’s piano lessions</p>
				<span class="ss-msg-amount">My share: <strong>£20.00</strong></span>
			</div>
			
			<div class="ss-schedules-msg">
				<span class="ss-msg-date">12th Jul 2019</span>
				<p class="ss-msg-text">Shared expenses recuring payment with spouse Janny Black</p>
				<span class="ss-msg-amount">My share: <strong>£380.00</strong></span>
			</div>
			
			<div class="ss-schedules-msg">
				<span class="ss-msg-date">15th Jul 2019</span>
				<p class="ss-msg-text">Child Maintenance Weekly payment for Jack’s piano lessions</p>
				<span class="ss-msg-amount">My share: <strong>£20.00</strong></span>
			</div>
			
			<div class="ss-schedule-msg">
				<span class="ss-msg-date">15th Jul 2019</span>
				<p class="ss-msg-text">Child Maintenance Weekly payment for Jack’s piano lessions</p>
				<span class="ss-msg-amount">My share: <strong>£20.00</strong></span>
			</div>
			
			<div class="ss-schedules-msg">
				<span class="ss-msg-date">15th Jul 2019</span>
				<p class="ss-msg-text">Child Maintenance Weekly payment for Jack’s piano lessions</p>
				<span class="ss-msg-amount">My share: <strong>£20.00</strong></span>
			</div>
			
			<div class="ss-schedules-msg">
				<span class="ss-msg-date">15th Jul 2019</span>
				<p class="ss-msg-text">Child Maintenance Weekly payment for Jack’s piano lessions</p>
				<span class="ss-msg-amount">My share: <strong>£20.00</strong></span>
			</div>
			
			<div class="ss-schedules-msg">
				<span class="ss-msg-date">15th Jul 2019</span>
				<p class="ss-msg-text">Child Maintenance Weekly payment for Jack’s piano lessions</p>
				<span class="ss-msg-amount">My share: <strong>£20.00</strong></span>
			</div>
			
			<div class="ss-schedules-msg">
				<span class="ss-msg-date">15th Jul 2019</span>
				<p class="ss-msg-text">Child Maintenance Weekly payment for Jack’s piano lessions</p>
				<span class="ss-msg-amount">My share: <strong>£20.00</strong></span>
			</div>
			
			<div class="ss-schedules-msg">
				<span class="ss-msg-date">15th Jul 2019</span>
				<p class="ss-msg-text">Child Maintenance Weekly payment for Jack’s piano lessions</p>
				<span class="ss-msg-amount">My share: <strong>£20.00</strong></span>
			</div>
			
			<div class="ss-schedules-msg">
				<span class="ss-msg-date">15th Jul 2019</span>
				<p class="ss-msg-text">Child Maintenance Weekly payment for Jack’s piano lessions</p>
				<span class="ss-msg-amount">My share: <strong>£20.00</strong></span>
			</div>
			
			<div class="ss-schedules-msg">
				<span class="ss-msg-date">15th Jul 2019</span>
				<p class="ss-msg-text">Child Maintenance Weekly payment for Jack’s piano lessions</p>
				<span class="ss-msg-amount">My share: <strong>£20.00</strong></span>
			</div>
		
		</div>
	</div>
</template>

<script>
  export default {

  }
</script>
